import { render, staticRenderFns } from "./trending.vue?vue&type=template&id=99da0530&scoped=true&"
import script from "./trending.vue?vue&type=script&lang=js&"
export * from "./trending.vue?vue&type=script&lang=js&"
import style0 from "./trending.vue?vue&type=style&index=0&id=99da0530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99da0530",
  null
  
)

export default component.exports